import { defineMessages, useIntl } from "react-intl";
import type { ReactNode } from "react";
import classnames from "classnames";

import { IconButton } from "common/core/button/icon_button";

import Styles from "./index.module.scss";

const MESSAGES = defineMessages({
  expand: {
    id: "305038c8-df4e-4255-9a52-b74fadf6e341",
    defaultMessage: "Expand content",
  },
  collapse: {
    id: "49a6dc64-ba50-46aa-a168-ebccb7fd1e24",
    defaultMessage: "Collapse content",
  },
});

export function DisclosureContent({
  children,
  className,
  expanded,
  id,
}: {
  children: ReactNode;
  className?: string;
  expanded: boolean;
  id?: string;
}) {
  return (
    <div className={classnames(Styles.collapsible, expanded && Styles.expanded)} id={id}>
      <div className={classnames(Styles.content, className)}>{children}</div>
    </div>
  );
}

export function DisclosureToggle({
  onClick,
  expanded,
  controlsId,
}: {
  onClick: () => void;
  expanded: boolean;
  controlsId?: string;
}) {
  const intl = useIntl();
  return (
    <IconButton
      buttonColor="dark"
      variant="tertiary"
      buttonSize="condensed"
      onClick={onClick}
      aria-expanded={expanded}
      label={intl.formatMessage(expanded ? MESSAGES.collapse : MESSAGES.expand)}
      name={expanded ? "caret-up" : "caret-down"}
      aria-controls={controlsId ? controlsId : undefined}
    />
  );
}
